import React, {Component} from 'react';
import axios from "axios";
import Select from "react-select";
import Button from "react-bootstrap/Button";

import classes from'./GameTypesInput.module.css';
import NewGameType from "../NewGameType/NewGameType";
import apiUrl from "../../../shared/config";

class GameTypesInput extends Component  {
    state = {
        game_types: [],
        selected_game_types: [],
        new_game_type: false
    };

    componentDidMount() {
        if (this.state.game_types !== []) {
            axios.get(apiUrl +'GameTypes/getGameTypes')
                .then(response => {
                    this.setState({game_types: response.data});
                });
        }
        this.setState({selected_game_types: this.props.gameTypes});
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps !== this.props) {
            this.setState({selected_game_types: this.props.gameTypes})
        }
    }

    addGameType = () => {
        this.setState(
            {selected_game_types: [
                    ...this.state.selected_game_types,
                    {
                        game_type_id: null
                    }]
            });
    };

    newGameTypeToggle = () => {
        this.setState({new_game_type: !this.state.new_game_type});
    };

    newGameTypesHandler = (new_game_type_add) => {
        this.setState({game_types: [new_game_type_add, ...this.state.game_types]});
    };

    arraySearch(arr,val) {
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].value === val)
                return i;
        }
        return -1;
    }

    render() {
        let game_types_input_element = null;
        if (this.state.game_types && this.state.game_types.length) {
            const gameTypesOptions = this.state.game_types
                .map( game_type => ({value: game_type.game_type_id, label: game_type.game_type_name}));

            if (this.state.selected_game_types && this.state.selected_game_types.length) {
                let game_types_index = 0;
                let selected_game_types = [...this.state.selected_game_types];
                game_types_input_element = (
                    <>
                        <dd className="col-sm-9">
                            {selected_game_types.map(game_type => {
                                let game_types_index_local = game_types_index;
                                const game_type_id = selected_game_types[game_types_index_local].game_type_id;
                                const default_index = this.arraySearch(gameTypesOptions, game_type_id);
                                let default_value = {label: "Add a type for this game."};
                                if (game_type_id !== null) {
                                    default_value = gameTypesOptions[default_index];
                                }
                                const game_type_jsx = (
                                    <div className={classes.GameTypesBlock} key={game_type_id}>
                                        <Select
                                            className={classes.GameTypesSelect}
                                            defaultValue={{
                                                value: selected_game_types[game_types_index_local].game_type_id,
                                                label: default_value.label,
                                                isFixed: true,
                                                isDisabled: true
                                            }}
                                            options={gameTypesOptions}
                                            closeMenuOnSelect={true}
                                            onChange={(val) => {
                                                let game_types_local = [...selected_game_types];
                                                game_types_local[game_types_index_local] = {
                                                    game_type_id: val.value
                                                };
                                                this.setState({selected_game_types: game_types_local});
                                                this.props.gameTypesUpdate(game_types_local);
                                            }}
                                        />
                                        <div className={classes.DeleteGameTypes}>
                                            <Button className={classes.DeleteGameTypesButton} size="sm" variant={"outline-danger"} onClick={() => {
                                                let filtered_array = selected_game_types.filter((value,index,array) => {
                                                    return index !== (game_types_index_local)
                                                });
                                                this.setState({selected_game_types: filtered_array});
                                                this.props.gameTypesUpdate(filtered_array);
                                            }}>X</Button>
                                        </div>
                                    </div>
                                );
                                game_types_index++;

                                return game_type_jsx;
                            })}
                        </dd>
                        <dt className="col-sm-3"> </dt>
                    </>
                );
            }
        }

        let new_game_type_jsx = '';
        if (this.state.new_game_type === true) {
            new_game_type_jsx = (<NewGameType
                game_types={this.state.game_types}
                newGameTypeToggle={this.newGameTypeToggle}
                onNewGameType={this.newGameTypesHandler}
            />);
        }

        return (
            <dl className="row">
                <dt className="col-sm-3"><label>Game Types</label></dt>
                {game_types_input_element}
                {new_game_type_jsx}
                <dd className="col-sm-6"><Button className="col-sm-12" variant="outline-primary" onClick={this.addGameType} disabled={this.state.new_game_type}>Add Game Type to Game</Button></dd>
                <dd className="col-sm-3"><Button className="col-sm-12" variant="outline-secondary" onClick={this.newGameTypeToggle} disabled={this.state.new_game_type}>Enter New Game Type</Button></dd>
            </dl>
        );
    }
}

export default GameTypesInput;